import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-735d0d0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left" }
const _hoisted_2 = { class: "right" }

import { computed } from 'vue';
import User from './components/User.vue';
import LoginRight from './components/LoginRight.vue';
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const store = useStore();
const rightRef = ref<any>(null);
const isToken = computed(() => store.getters.getoken);
// 成功登陸
const handleLogin = () => {
  // rightRef.value.getData()
};

// 成功登出
const handleLogout = () => {
  // rightRef.value.getData()
};
onMounted(() => {
  store.dispatch('setlocaload');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row", {'isLogin': isToken.value}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(User, {
        onHandleLogin: handleLogin,
        onHandleLogout: handleLogout
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LoginRight, {
        ref_key: "rightRef",
        ref: rightRef
      }, null, 512)
    ])
  ], 2))
}
}

})